import {
  Box, IconButton, Typography, useTheme,
  TextField, CircularProgress, Container, Paper, InputAdornment, Skeleton
} from "@mui/material";
import { tokens } from "../../theme";
import SendIcon from '@mui/icons-material/Send';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from '@mui/icons-material/Refresh';
import { __fetching_data__ } from '../../components/api';
import { createChart, CrosshairMode, PriceScaleMode } from 'lightweight-charts';
import { useIsMobile, useIsPortraitTablet, useIsTablet } from '../../components/hooks';
import Autocomplete from '@mui/material/Autocomplete';
import { SaveAllIcon, ChevronLastIcon } from "lucide-react";
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import FastForwardIcon from '@mui/icons-material/FastForward';
import Papa from "papaparse";

var selectedTimezone = 'Asia/Bangkok';
var selectedChartSetting = null;
var isDragging = false;
var isChooseColor = false;
var selectLineWidth = 1;
var uniqueRandomColors = new Array();
var chartSize = 0;
const allChartDataList = [];
var globalResponse = null;

const viewportHeight = window.innerHeight;
const chartHeight = (viewportHeight - 50 - 45) / 3;

// ====================================================
// Toast System
// ====================================================
function ToastContainer({ toasts }) {
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-5 py-3 rounded-xl shadow-2xl border text-sm font-medium
            backdrop-blur-md transition-all duration-300 relative overflow-hidden
            ${toast.type === "success"
              ? "bg-[#0a1628]/90 border-cyan-500/40 text-cyan-200 shadow-[0_0_20px_rgba(6,182,212,0.15)]"
              : toast.type === "error"
                ? "bg-[#0a1628]/90 border-red-500/40 text-red-300 shadow-[0_0_20px_rgba(239,68,68,0.15)]"
                : "bg-[#0a1628]/90 border-slate-500/40 text-slate-300"
            }`}
          style={{ animation: "toastIn 0.3s cubic-bezier(0.34,1.56,0.64,1) forwards" }}
        >
          {toast.type === "success" && (
            <CheckCircleOutlineIcon fontSize="small" className="text-cyan-400 flex-shrink-0" />
          )}
          {toast.type === "error" && (
            <ErrorOutlineIcon fontSize="small" className="text-red-400 flex-shrink-0" />
          )}
          <span>{toast.message}</span>
          <div
            className={`absolute bottom-0 left-0 h-[2px] rounded-b-xl
              ${toast.type === "success" ? "bg-cyan-500" : toast.type === "error" ? "bg-red-500" : "bg-slate-500"}`}
            style={{ animation: `toastProgress ${toast.duration}ms linear forwards`, width: "100%" }}
          />
        </div>
      ))}
      <style>{`
        @keyframes toastIn {
          from { opacity:0; transform: translateY(12px) scale(0.95); }
          to   { opacity:1; transform: translateY(0) scale(1); }
        }
        @keyframes toastProgress {
          from { width:100%; }
          to   { width:0%; }
        }
      `}</style>
    </div>
  );
}

function useToast() {
  const [toasts, setToasts] = useState([]);
  const showToast = (message, type = "success", duration = 3000) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type, duration }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), duration);
  };
  return { toasts, showToast };
}

// ====================================================
// RightMenu (ย้ายออกมาเป็น top-level component แล้ว)
// แก้บัค: ห้ามประกาศ component ไว้ข้างในฟังก์ชัน render ของ component อื่น
// เพราะทุกครั้งที่ ChatBotV2Page re-render (เช่นตอน handleSendMessage
// เปลี่ยน state) มันจะสร้างฟังก์ชันใหม่ -> React unmount/remount
// RightMenu ตัวเก่า -> state ภายใน (tableRows, values, selectedRow)
// ถูกรีเซ็ต -> ตารางหายไป
// ====================================================
// function RightMenu({ handleSendMessage }) {
//   const [tableRows, setTableRows] = useState([]);
//   const [values, setValues] = useState([]);
//   const [selectedRow, setSelectedRow] = useState(-1); // -1 = ยังไม่เลือกแถวไหน

//   const containerRef = useRef(null);
//   const rowRefs = useRef([]);

//   // หา index ของคอลัมน์ที่ใช้เป็น "สัญลักษณ์" (เช่น PTT)
//   // ถ้าไม่มีคอลัมน์ชื่อ symbol ให้ใช้คอลัมน์แรก (index 0)
//   const symbolColIndex = (() => {
//     const idx = tableRows.findIndex((h) =>
//       h.toLowerCase().includes("symbol")
//     );
//     return idx !== -1 ? idx : 0;
//   })();

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;
//     Papa.parse(file, {
//       header: false, // Automatically keys data by column headers
//       skipEmptyLines: true,
//       complete: function (results) {
//         // Extract headers (keys from the first object)
//         // const rowsArray = Object.keys(results.data[0]);
//         // Extract row values
//         const valuesArray = results.data.map((d) => Object.values(d));
//         // console.log(valuesArray);
//         // setTableRows(rowsArray);
//         setValues(valuesArray);
//         setSelectedRow(valuesArray.length > 0 ? 0 : -1); // เลือกแถวแรกอัตโนมัติ
//       },
//     });
//   };

//   // ดักจับปุ่มลูกศรขึ้น/ลง เพื่อเลื่อนแถวที่เลือกในตาราง
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (values.length === 0) return;

//       if (e.key === "ArrowDown") {
//         e.preventDefault();
//         setSelectedRow((prev) =>
//           prev < values.length - 1 ? prev + 1 : prev
//         );
//       } else if (e.key === "ArrowUp") {
//         e.preventDefault();
//         setSelectedRow((prev) => (prev > 0 ? prev - 1 : prev));
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [values]);

//   // เลื่อนสกรอลให้แถวที่เลือกอยู่ในมุมมองเสมอ
//   // และเรียก handleSendMessage(symbol) เฉพาะตอนแถวที่เลือกเปลี่ยน
//   // (ครอบคลุมทั้งกรณีคลิกแถว และกดลูกศรขึ้น/ลง - ไม่เรียกซ้ำสองครั้ง)
//   useEffect(() => {
//     if (rowRefs.current[selectedRow]) {
//       rowRefs.current[selectedRow].scrollIntoView({
//         block: "nearest",
//         behavior: "smooth",
//       });
//     }

//     if (selectedRow !== -1 && values[selectedRow]) {
//       handleSendMessage(values[selectedRow][symbolColIndex]); // เช่น 'PTT'
//     }
//   }, [selectedRow]);

//   return (
//     <div ref={containerRef}>
//       <div>
//         <input
//           style={{ color: "black" }}
//           type="text"
//           placeholder=": Enter symbol"
//         />
//       </div>
//       <div>
//         <label htmlFor="file-upload">Choose a file:</label>
//         <input
//           type="file"
//           id="file-upload"
//           name="file-upload"
//           onChange={handleFileUpload}
//           accept=".txt, .csv, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
//         />
//       </div>

//       {/* Table Display */}
//       {values.length > 0 && (
//         <div style={{ maxHeight: "400px", overflowY: "auto" }}>
//           <table
//             border="1"
//             cellPadding="8"
//             style={{ borderCollapse: "collapse", width: "100%" }}
//           >
//             {tableRows.length > 0 && (
//               <thead>
//                 <tr>
//                   {tableRows.map((header, i) => (
//                     <th key={i}>Symbol list</th>
//                   ))}
//                 </tr>
//               </thead>
//             )}
//             <tbody>
//               {values.map((value, index) => (
//                 <tr
//                   key={index}
//                   ref={(el) => (rowRefs.current[index] = el)}
//                   onClick={() => setSelectedRow(index)}
//                   style={{
//                     backgroundColor:
//                       index === selectedRow ? "#cce5ff" : "transparent",
//                     color: index === selectedRow ? "black" : "white",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {value.map((val, i) => (
//                     <td key={i}>{val}</td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }
// ====================================================
// RightMenu (ย้ายออกมาเป็น top-level component แล้ว)
// แก้บัค: ห้ามประกาศ component ไว้ข้างในฟังก์ชัน render ของ component อื่น
// เพราะทุกครั้งที่ ChatBotV2Page re-render (เช่นตอน handleSendMessage
// เปลี่ยน state) มันจะสร้างฟังก์ชันใหม่ -> React unmount/remount
// RightMenu ตัวเก่า -> state ภายใน (tableRows, values, selectedRow)
// ถูกรีเซ็ต -> ตารางหายไป
// ====================================================
function RightMenuBackup({ handleSendMessage }) {
  const [tableRows, setTableRows] = useState([]);
  const [values, setValues] = useState([]);
  const [selectedRow, setSelectedRow] = useState(-1); // -1 = ยังไม่เลือกแถวไหน
  const [symbolInput, setSymbolInput] = useState(""); // ค่าในช่อง "Enter symbol"
  const tableContainerRef = useRef(null);

  const containerRef = useRef(null);
  const rowRefs = useRef([]);

  // หา index ของคอลัมน์ที่ใช้เป็น "สัญลักษณ์" (เช่น PTT)
  // ถ้าไม่มีคอลัมน์ชื่อ symbol ให้ใช้คอลัมน์แรก (index 0)
  const symbolColIndex = (() => {
    const idx = tableRows.findIndex((h) =>
      h.toLowerCase().includes("symbol")
    );
    return idx !== -1 ? idx : 0;
  })();

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    Papa.parse(file, {
      header: false, // ไฟล์เป็นรายชื่อ symbol ล้วนๆ ไม่มีแถวหัวตาราง
      skipEmptyLines: true,
      complete: function (results) {
        // results.data เป็น array ของ array อยู่แล้ว เช่น [["PTT"], ["BANPU"], ...]
        const valuesArray = results.data;
        setTableRows([]); // ไม่มีแถวหัวตารางจากไฟล์
        setValues(valuesArray);
        setSelectedRow(valuesArray.length > 0 ? 0 : -1); // เลือกแถวแรกอัตโนมัติ
        setTimeout(() => tableContainerRef.current?.focus(), 0);
      },
    });
  };

  // เพิ่ม symbol ที่พิมพ์ลงไปในตาราง แล้วเลือกแถวนั้นทันที (ส่งต่อให้ handleSendMessage ด้วย)
  const handleAddSymbol = () => {
    const symbol = symbolInput.trim().toUpperCase();
    if (!symbol) return;

    // const newIndex = values.length; // index ของแถวใหม่ที่กำลังจะเพิ่ม
    setValues((prev) => [...prev, [symbol]]);
    // setSelectedRow(newIndex);
    setSymbolInput("");
  };

  // ดักจับปุ่มลูกศรขึ้น/ลง เพื่อเลื่อนแถวที่เลือกในตาราง
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (values.length === 0) return;

      // ถ้ากำลังพิมพ์อยู่ในช่อง input/textarea ให้ปล่อยให้ลูกศรขึ้น/ลง
      // ทำงานตามปกติของช่องนั้น ไม่ไปเลื่อนแถวในตาราง
      const tag = e.target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA") return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedRow((prev) =>
          prev < values.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedRow((prev) => (prev > 0 ? prev - 1 : prev));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [values]);

  // เลื่อนสกรอลให้แถวที่เลือกอยู่ในมุมมองเสมอ
  // และเรียก handleSendMessage(symbol) เฉพาะตอนแถวที่เลือกเปลี่ยน
  // (ครอบคลุมทั้งกรณีคลิกแถว และกดลูกศรขึ้น/ลง - ไม่เรียกซ้ำสองครั้ง)
  useEffect(() => {
    if (rowRefs.current[selectedRow]) {
      rowRefs.current[selectedRow].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }

    if (selectedRow !== -1 && values[selectedRow]) {
      handleSendMessage(values[selectedRow][symbolColIndex]); // เช่น 'PTT'
    }
  }, [selectedRow]);

  return (
    <div ref={containerRef}>
      <div>
        <input
          style={{ color: "black" }}
          type="text"
          placeholder=": Enter symbol"
          value={symbolInput}
          onChange={(e) => setSymbolInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddSymbol();
            }
          }}
        />
      </div>
      <div>
        <label htmlFor="file-upload">Choose a file:</label>
        <input
          type="file"
          id="file-upload"
          name="file-upload"
          onChange={handleFileUpload}
          accept=".txt, text/plain"
        />
      </div>

      {/* Table Display */}
      {values.length > 0 && (
        <div
          ref={tableContainerRef}
          tabIndex={-1}
          style={{
            height: "400px",       // ใช้ height ตายตัวแทน maxHeight
            overflowY: "scroll",   // ใช้ scroll แทน auto เพื่อบังคับให้เห็น scrollbar เสมอ (ทดสอบก่อน ค่อยเปลี่ยนกลับเป็น auto ทีหลังได้)
            outline: "none",
            display: "block",
          }}
        >
          <table
            border="1"
            cellPadding="8"
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            {values[0]?.length > 0 && (
              <thead>
                <tr>
                  {values[0].map((_, i) => (
                    <th key={i}>Symbol list</th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {values.map((value, index) => (
                <tr
                  key={index}
                  ref={(el) => (rowRefs.current[index] = el)}
                  onClick={() => setSelectedRow(index)}
                  style={{
                    backgroundColor:
                      index === selectedRow ? "#cce5ff" : "transparent",
                    color: index === selectedRow ? "black" : "white",
                    cursor: "pointer",
                  }}
                >
                  {value.map((val, i) => (
                    <td key={i}>{val}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


function RightMenu({ handleSendMessage }) {
  const [tableRows, setTableRows] = useState([]);
  const [values, setValues] = useState([]);
  const [selectedRow, setSelectedRow] = useState(-1); // -1 = ยังไม่เลือกแถวไหน
  const [symbolInput, setSymbolInput] = useState(""); // ค่าในช่อง "Enter symbol"
  const tableContainerRef = useRef(null);

  const containerRef = useRef(null);
  const rowRefs = useRef([]);

  // หา index ของคอลัมน์ที่ใช้เป็น "สัญลักษณ์" (เช่น PTT)
  // ถ้าไม่มีคอลัมน์ชื่อ symbol ให้ใช้คอลัมน์แรก (index 0)
  const symbolColIndex = (() => {
    const idx = tableRows.findIndex((h) =>
      h.toLowerCase().includes("symbol")
    );
    return idx !== -1 ? idx : 0;
  })();

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    Papa.parse(file, {
      header: false, // ไฟล์เป็นรายชื่อ symbol ล้วนๆ ไม่มีแถวหัวตาราง
      skipEmptyLines: true,
      complete: function (results) {
        // results.data เป็น array ของ array อยู่แล้ว เช่น [["PTT"], ["BANPU"], ...]
        const valuesArray = results.data;
        setTableRows([]); // ไม่มีแถวหัวตารางจากไฟล์
        setValues(valuesArray);
        setSelectedRow(valuesArray.length > 0 ? 0 : -1); // เลือกแถวแรกอัตโนมัติ
        setTimeout(() => tableContainerRef.current?.focus(), 0);
      },
    });
  };

  // เพิ่ม symbol ที่พิมพ์ลงไปในตาราง แล้วเลือกแถวนั้นทันที (ส่งต่อให้ handleSendMessage ด้วย)
  const handleAddSymbol = () => {
    const symbol = symbolInput.trim().toUpperCase();
    if (!symbol) return;

    // const newIndex = values.length; // index ของแถวใหม่ที่กำลังจะเพิ่ม
    setValues((prev) => [...prev, [symbol]]);
    // setSelectedRow(newIndex);
    setSymbolInput("");
  };

  // ดักจับปุ่มลูกศรขึ้น/ลง เพื่อเลื่อนแถวที่เลือกในตาราง
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (values.length === 0) return;

      // ถ้ากำลังพิมพ์อยู่ในช่อง input/textarea ให้ปล่อยให้ลูกศรขึ้น/ลง
      // ทำงานตามปกติของช่องนั้น ไม่ไปเลื่อนแถวในตาราง
      const tag = e.target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA") return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedRow((prev) =>
          prev < values.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedRow((prev) => (prev > 0 ? prev - 1 : prev));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [values]);

  // เลื่อนสกรอลให้แถวที่เลือกอยู่ในมุมมองเสมอ
  // และเรียก handleSendMessage(symbol) เฉพาะตอนแถวที่เลือกเปลี่ยน
  // (ครอบคลุมทั้งกรณีคลิกแถว และกดลูกศรขึ้น/ลง - ไม่เรียกซ้ำสองครั้ง)
  useEffect(() => {
    if (rowRefs.current[selectedRow]) {
      rowRefs.current[selectedRow].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }

    if (selectedRow !== -1 && values[selectedRow]) {
      handleSendMessage(values[selectedRow][symbolColIndex]); // เช่น 'PTT'
    }
  }, [selectedRow]);

  return (
    <div
      className="w-full flex flex-col"
      ref={containerRef}>
      <div className="relative">
        <SearchIcon className="absolute left-1 top-1/2 -translate-y-1/2 text-slate-400" fontSize="small" />
        <input
          type="text"
          placeholder=": Enter symbol"
          value={symbolInput}
          onChange={(e) => setSymbolInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddSymbol();
            }
          }}
          className="w-full bg-[#0f172a] border border-slate-600 rounded-lg pl-5 pr-1 py-2 text-sm text-white focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition"
        />
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm leading-none">▾</span>
      </div>
      <div style={{ display: 'none' }}>
        <input
          style={{ color: "black" }}
          type="text"
          placeholder=": Enter symbol"
          value={symbolInput}
          onChange={(e) => setSymbolInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddSymbol();
            }
          }}
        />
      </div>
      <div>
        <label htmlFor="file-upload">Choose a file:</label>
        <input
          type="file"
          id="file-upload"
          name="file-upload"
          onChange={handleFileUpload}
          accept=".txt, text/plain"
        />
      </div>

      {/* Table Display */}
      {values.length > 0 && (
        <div
          ref={tableContainerRef}
          tabIndex={-1}
          style={{
            overflowY: "auto",
            outline: "none",
            maxHeight: (chartHeight * 3-70) + "px", // สูงเท่ากับกราฟทั้ง 3 แถวรวมกัน
          }}
        >
          <table
            border="1"
            cellPadding="8"
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            {values[0]?.length > 0 && (
              <thead>
                <tr>
                  {values[0].map((_, i) => (
                    <th key={i}>Symbol list</th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {values.map((value, index) => (
                <tr
                  key={index}
                  ref={(el) => (rowRefs.current[index] = el)}
                  onClick={() => setSelectedRow(index)}
                  style={{
                    backgroundColor:
                      index === selectedRow ? "#cce5ff" : "transparent",
                    color: index === selectedRow ? "black" : "white",
                    cursor: "pointer",
                  }}
                >
                  {value.map((val, i) => (
                    <td key={i}>{val}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


// ====================================================
// MAIN COMPONENT
// ====================================================
const ChatBotV2Page = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useIsMobile();

  const [loading, setLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const { toasts, showToast } = useToast();

  let [ddlChartOrder, setDDLChartOrder] = useState([]);
  let [oldChartOrder, setOldChartOrder] = useState([]);

  let [ddlList, setDdlList] = useState(new Map([
    ['Last', 1], ['%Short', 2], ['PredictTrend', 3],
    ['Peak', 4], ['Shareholder', 5], ['manager', 6]
  ]));

  let [chartOrder, setChartOrder] = useState(new Map([
    ['Last', 1], ['%Short', 2], ['PredictTrend', 3],
    ['Peak', 4], ['Shareholder', 5], ['manager', 6]
  ]));

  let newChartOrder = undefined;

  const locations = useLocation();
  const searchParams = new URLSearchParams(locations.search);
  const isS50 = searchParams.get('isS50') === 'true';

  const [selectedCategory, setSelectedCategory] = useState('');

  const categoryMap = {
    'พลังงาน': ['BANPU', 'BGRIM', 'EGCO', 'GPSC', 'GULF', 'OR', 'PTT', 'PTTEP', 'PTTGC', 'RATCH', 'TOP', 'IVL'],
    'การเงิน': ['BBL', 'KBANK', 'KTB', 'SCB', 'TISCO', 'TTB', 'KTC', 'SAWAD', 'MTC', 'TLI'],
    'เทคโนโลยี': ['ADVANC', 'DELTA', 'COM7', 'CCET', 'TRUE'],
    'ค้าปลีก': ['CPALL', 'CPF', 'CBG', 'OSP', 'GLOBAL', 'HMPRO', 'BJC', 'CRC', 'ITC', 'TU'],
    'บริการ': ['AOT', 'AWC', 'BDMS', 'BH', 'BEM', 'BTS', 'CPN', 'LH', 'MINT', 'SCGP', 'SCC', 'VGI', 'WHA']
  };
  const filteredSymbols = selectedCategory
    ? categoryMap[selectedCategory]
    : Object.values(categoryMap).flat();

  const userDetail = useSelector((state) => state.userDetail);
  const base_api_url =
    process.env.NODE_ENV === "production"
      ? window.location.protocol === "https:"
        ? process.env.REACT_APP_API_HTTPS_URL
        : process.env.REACT_APP_API_HTTP_URL
      : "/application";

  const [isMessageSent, setIsMessageSent] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [isSymbolSelected, setIsSymbolSelected] = useState(false);

  const messagesEndRef = useRef(null);
  const searchInputRef = useRef(null);
  const resChatBoxRef = useRef(null);

  const csrfToken = useSelector(s => s.csrfToken);
  const base = window.config?.base_api_url;

  // ── Scroll helpers ──────────────────────────────
  const scrollToBottomChatbot = () => {
    resChatBoxRef.current && (resChatBoxRef.current.scrollTop = resChatBoxRef.current.scrollHeight);
  };

  useEffect(() => { scrollToBottomChatbot(); }, [isMessageSent]);

  // ── Init ─────────────────────────────────────────
  useEffect(() => {
    const fetchData = async () => {
      const res = await __fetching_data__({ url: `${base_api_url}/chartorder/load`, method: "POST" });
      if (res?.data) {
        newChartOrder = new Map();
        for (let i = 0; i < res.data.length; i++) {
          newChartOrder.set(res.data[i], i + 1);
        }
        chartOrder = new Map(newChartOrder);
        setChartOrder(chartOrder);
      }

      await generateEmptyChart();

      // หน่วงเวลา Skeleton ตอนโหลดเข้าหน้าเว็บครั้งแรกให้นานขึ้น (1500 ms)
      setTimeout(() => {
        setIsInitialLoading(false);
      }, 1500);

    };
    fetchData();
  }, []);

  function resetAllChartOrder() {
    const chartResponse = document.getElementById('chart_response');
    if (chartResponse) chartResponse.remove();
    const newCO = new Map([
      ['Last', 1], ['%Short', 2], ['PredictTrend', 3],
      ['Peak', 4], ['Shareholder', 5], ['manager', 6]
    ]);
    chartOrder = newCO;
    setChartOrder(newCO);
    oldChartOrder = [];
    ddlChartOrder = [];
    setOldChartOrder(oldChartOrder);
    setDDLChartOrder(ddlChartOrder);
    generateEmptyChart();
  }

  // ── Generate empty chart ─────────────────────────
  const generateEmptyChart = async () => {
    const emptyData = {
      all_59: [], all_246: [], bidask: [], flow_accum: [], high: [], low: [],
      name_59: ['date'], name_246: ['date'], open: [], outstanding_short: [],
      point_data: [], price: [], s50_scoring: [], short: [], swap: [],
      max_peaks: { swap: { max: [], min: [] } },
      symbol: ''
    };
    const waitForElement = (id, retries = 20) => new Promise((resolve) => {
      const el = document.getElementById(id);
      if (el) return resolve(el);
      if (retries <= 0) return resolve(null);
      setTimeout(() => waitForElement(id, retries - 1).then(resolve), 100);
    });
    const chatboxEmpty = await waitForElement('chatboxEmpty');
    if (!chatboxEmpty) return;

    chatboxEmpty.innerHTML = '';
    const responseContainer = await displayPlot({ plot_data: emptyData }, [], [], true);
    chatboxEmpty.appendChild(responseContainer);
  };

  const [chartIdx, setChartIdx] = useState(0);

  const handleSendMessage = async (symbolOverride) => {
    const symbolToSend = (symbolOverride || inputValue).trim().toUpperCase();
    if (!symbolToSend) return;

    setChartIdx(e => e + 1);
    chartSize = chartSize + 1;
    setIsMessageSent(true);
    setInputValue('');
    setMessages(prev => [...prev, { text: `You: ${symbolToSend}`, isBot: true }]);

    const value = { user_input: symbolToSend };
    const [response, eventsRes] = await Promise.all([
      __fetching_data__({ url: `${base_api_url}/chat_bot_report`, method: "POST", body: JSON.stringify(value) }),
      // __fetching_data__({ url: `${base_api_url}/api/symbols/${symbolToSend}`, method: "GET" })
    ]);

    const chatboxEmpty = document.getElementById('chatboxEmpty');
    if (chatboxEmpty) chatboxEmpty.innerHTML = '';

    const chatbox = document.getElementById('chatbox');
    if (!chatbox) return;
    chatbox.innerHTML = '';
    chatbox.style.display = 'block';
    setIsSymbolSelected(true);

    if (response?.status) {
      window.data = response.data;
      window.bdata = response.bdata;

      if (response.data?.bot_response) {
        responses.push(response.data);
        displayResponse(response.data, symbolToSend);
      } else if (response.data) {
        globalResponse = response;

        const responseContainer = await displayPlot(response.data, response.bdata, eventsRes, false, symbolToSend);
        const chartResponse = document.getElementById('chart_response');
        if (chartResponse) chartResponse.remove();
        chatbox.appendChild(responseContainer);

        // ✅ เพิ่มตรงนี้
        setTimeout(() => {
          if (window.myCharts?.['chart']) {
            window.myCharts['chart'].timeScale().scrollToPosition(5, false);
          }
        }, 200);
      }
    }

    setIsMessageSent(false);
  };

  const responses = [];

  // ── displayPlot ──────────────────────────────────
  const displayPlot = async (response, bresponse, corporateEvents, isEmpty = false, symbol = '') => {
    const plotData = response.plot_data ?? response;
    const bData = bresponse;
    window.plotData = plotData;

    const responseContainer = document.createElement('div');
    responseContainer.id = 'chart_response';
    responseContainer.classList.add('response-container');
    responseContainer.style.display = 'grid';
    responseContainer.style.padding = '0px';
    responseContainer.style.justifyItems = 'center';
    responseContainer.style.width = isMobile ? '180%' : '100%';
    responseContainer.style.gridTemplateColumns = `repeat(2, 1fr)`;
    responseContainer.style.gap = '8px';
    responseContainer.style.background = '#0B0E14';

    const chartOption = {
      crosshair: { mode: 0 },
      timeScale: { visible: true },
      layout: {
        background: { type: 'solid', color: '#131722' },
        textColor: '#787B86',
      },
      grid: {
        vertLines: { color: '#2B3139' },
        horzLines: { color: '#2B3139' },
      },
    };

    function chartAnnotation(chart, text) {
      chart.applyOptions({
        watermark: {
          visible: true, fontSize: 24,
          horzAlign: 'left', vertAlign: 'top',
          color: 'rgb(0,0,0)', text: symbol,
        },
        rightPriceScale: { visible: true },
        leftPriceScale: {
          visible: true, mode: PriceScaleMode.Normal,
          autoScale: true, invertScale: false,
          alignLabels: false, minValue: -1, maxValue: 1,
        },
      });
    }

    function addDummyData(chart) {
      const dummySeries = chart.addLineSeries({ color: 'transparent', crosshairMarkerVisible: false, priceLineVisible: false });
      const dummyData = [];
      let currentTime = Math.floor(Date.now() / 1000) - (120 * 86400);
      for (let i = 0; i <= 10; i++) {
        dummyData.push({ time: currentTime + (i * 12 * 86400), value: i / 10 });
      }
      dummySeries.setData(dummyData);
      chart.timeScale().fitContent();
    }

    const isDataEmpty = !plotData || !plotData['price'] || plotData['price'].length <= 1;

    function syncByMinLength(dataSets, preserveLastIndex = null) {
      const minLength = Math.min(...dataSets.map(d => d.length));
      return dataSets.map((d, i) =>
        i === preserveLastIndex ? d.slice(-minLength) : d.slice(0, minLength)
      );
    }

    const data1 = plotData['price'] || [];
    const data2 = plotData['swap'] || [];
    const [filteredData1, filteredData2] = syncByMinLength([data1, data2], 1);

    function getByValue(searchValue) {
      for (let [key, value] of chartOrder.entries()) { if (value === searchValue) return key; }
    }

    function createOrderSelection(chartContainer, idxSelect, valueKey) {
      const selectChartOrder = document.createElement("select");
      selectChartOrder.id = idxSelect;

      let newCO = new Map();
      if (ddlChartOrder.indexOf(valueKey) !== -1) {
        newCO = new Map(JSON.parse(JSON.stringify(Array.from(ddlList))));
      } else {
        for (const [key, value] of ddlList.entries()) {
          if (ddlChartOrder.indexOf(key) === -1) newCO.set(key, value);
        }
      }

      const chatbox = document.getElementById('chatbox');
      for (const [key, value] of new Map(newCO)) {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = key;
        if (key === valueKey) option.selected = true;
        selectChartOrder.onchange = async (e) => {
          setLoading(true);
          const chartResponse = document.getElementById('chart_response');
          if (chartResponse) chartResponse.remove();
          const onChangeIdx = parseInt(e.target.value);
          const olderLabel = getByValue(idxSelect);
          const newLabel = getByValue(onChangeIdx);
          chartOrder.set(olderLabel, onChangeIdx);
          chartOrder.set(newLabel, idxSelect);
          ddlList.set(olderLabel, onChangeIdx);
          ddlList.set(newLabel, idxSelect);
          setDdlList(ddlList);
          setChartOrder(chartOrder);
          var res = globalResponse;
          oldChartOrder.push(olderLabel);
          ddlChartOrder.push(newLabel);
          setOldChartOrder(oldChartOrder);
          setDDLChartOrder(ddlChartOrder);
          if (res) {
            const currentSymbol = res.data?.symbol || symbol;
            const rc = await displayPlot(res.data, res.bdata, [], false, currentSymbol);
            chatbox.appendChild(rc);
          } else { generateEmptyChart(); }
          setLoading(false);
        };
        selectChartOrder.appendChild(option);
      }
      selectChartOrder.setAttribute('class', 'header-selection');
      chartContainer.appendChild(selectChartOrder);
    }

    // ── Chart 1: Last ────────────────────────────────
    function generateChartLast() {
      const chartContainer = document.createElement('div');
      chartContainer.classList.add('chart-container');
      chartContainer.style.position = 'relative';
      chartContainer.style.borderRadius = '8px';
      chartContainer.style.overflow = 'hidden';
      chartContainer.style.border = '1px solid #2B3139';
      chartContainer.style.width = '100%';
      chartContainer.style.height = chartHeight + 'px';
      chartContainer.setAttribute('id', 'chart-1');

      const tooltip = document.createElement('div');
      Object.assign(tooltip.style, {
        position: 'absolute', display: 'none', background: 'white', color: '#000',
        border: '1px solid #ccc', padding: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
        fontSize: '12px', maxWidth: '200px', pointerEvents: 'none', zIndex: '9999',
      });
      document.body.appendChild(tooltip);

      const chart = createChart(chartContainer, { ...chartOption, width: chartContainer.offsetWidth, height: chartContainer.offsetHeight });
      chartAnnotation(chart, 'Last');

      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) requestAnimationFrame(() => chart.applyOptions({ width: entry.contentRect.width, height: entry.contentRect.height }));
      });
      resizeObserver.observe(chartContainer);
      createOrderSelection(chartContainer, 1, 'Last');

      let activeSeries = [];

      if (isDataEmpty) {
        chart.applyOptions({
          watermark: { visible: true, fontSize: 22, horzAlign: 'center', vertAlign: 'center', color: '#D1D4DC', text: "Please select symbol", fontFamily: 'Roboto' },
          layout: { attributionLogo: false, background: { type: 'solid', color: '#131722' }, textColor: '#787B86' },
          grid: { horzLines: { color: '#2B3139' }, vertLines: { color: '#2B3139' } },
        });
        addDummyData(chart);
      } else {
        const close_series = chart.addLineSeries({ title: '', color: '#00A5E3', lastValueVisible: true, priceLineVisible: false, priceScaleId: 'right', CrosshairMarkerVisible: false });
        activeSeries = [close_series]; // เก็บเข้า Array สำหรับ Sync

        chart.applyOptions({
          watermark: { visible: true, fontSize: 24, horzAlign: 'center', vertAlign: 'center', color: theme.palette.chart.watermark, text: symbol },
          layout: { attributionLogo: false, background: { type: 'solid', color: theme.palette.background.default }, textColor: theme.palette.text.primary },
          grid: { horzLines: { color: theme.palette.divider }, vertLines: { color: theme.palette.divider } },
        });
        chart.applyOptions({ priceScale: { position: 'left', autoScale: true, invertScale: false, alignLabels: true, borderVisible: true, entireTextOnly: true } });

        const bar1 = chart.addAreaSeries({ topColor: 'rgba(255, 99, 71, 1)', bottomColor: 'rgba(255, 99, 71, 0.8)', lineStyle: 0, crosshairMarkerVisible: false, priceLineVisible: false });
        const bar2 = chart.addAreaSeries({ topColor: 'rgba(60, 179, 113, 1)', bottomColor: 'rgba(60, 179, 113, 0)', lineStyle: 0, crosshairMarkerVisible: false });
        const bar3 = chart.addAreaSeries({ topColor: 'rgba(255, 165, 0, 0.6)', bottomColor: 'rgba(255, 165, 0, 0)', crosshairMarkerVisible: false });

        const dataForSeries = generateData(plotData['price'], 'time', 'value');
        close_series.setData(dataForSeries);

        const tooltipEl = document.createElement('div');
        Object.assign(tooltipEl.style, {
          position: 'absolute', display: 'none', pointerEvents: 'none',
          background: 'white', border: '1px solid #ccc', padding: '8px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)', fontSize: '12px', maxWidth: '200px', zIndex: '10001',
        });
        chartContainer.appendChild(tooltipEl);

        function renderMarkers(corporateEvents = []) {
          chartContainer.querySelectorAll('.marker-pane, .event-marker').forEach(n => n.remove());
          tooltipEl.style.display = 'none';
          const priceScaleWidth = chart.priceScale('right').width();
          const pane = document.createElement('div');
          Object.assign(pane.style, {
            position: 'absolute', left: '57px', right: `${priceScaleWidth}px`,
            bottom: '30px', height: '16px', overflow: 'hidden', pointerEvents: 'none',
          });
          pane.className = 'marker-pane';
          chartContainer.appendChild(pane);

          const tzOffset = 7 * 3600 * 1000;
          if (!Array.isArray(corporateEvents)) return;
          corporateEvents.forEach(evt => {
            const t = (new Date(evt.date).getTime() + tzOffset) / 1000;
            const x = chart.timeScale().timeToCoordinate(t);
            if (x == null) return;
            const bg = (evt.appoint.length && evt.resign.length)
              ? 'conic-gradient(#4caf50 0deg 180deg, #f44336 180deg 360deg)'
              : (evt.appoint.length ? '#4caf50' : '#f44336');
            const m = document.createElement('div');
            Object.assign(m.style, {
              position: 'absolute', left: `${x - 8}px`, bottom: '0px',
              width: '16px', height: '16px', lineHeight: '16px',
              textAlign: 'center', fontSize: '10px', borderRadius: '50%',
              background: bg, color: 'white', cursor: 'pointer',
              pointerEvents: 'auto', zIndex: '10002', userSelect: 'none',
            });
            m.className = 'event-marker';
            m.textContent = 'C';
            m.addEventListener('click', (ev) => {
              let html = `<div style="font-weight:bold;margin-bottom:4px;">${evt.date}</div>`;
              if (evt.appoint.length) html += `<div style="font-weight:bold;margin-top:6px;">Appoint:</div><ul style="margin:0;padding-left:16px;">${evt.appoint.map(n => `<li>${n}</li>`).join('')}</ul>`;
              if (evt.resign.length) html += `<div style="font-weight:bold;margin-top:6px;">Resign:</div><ul style="margin:0;padding-left:16px;">${evt.resign.map(n => `<li>${n}</li>`).join('')}</ul>`;
              tooltip.innerHTML = html;
              tooltip.style.left = (ev.pageX + 10) + 'px';
              tooltip.style.top = (ev.pageY - tooltip.offsetHeight - 10) + 'px';
              tooltip.style.display = 'block';
            });
            pane.appendChild(m);
          });
        }
        chart.timeScale().subscribeVisibleTimeRangeChange(() => { tooltip.style.display = 'none'; renderMarkers(corporateEvents); });
        renderMarkers(corporateEvents);
        setTimeout(() => { chart.timeScale().applyOptions({ rightOffset: 5 }); }, 100);
      }
      return [chart, activeSeries, chartContainer];
    }

    // ── Chart 2: %Short ──────────────────────────────
    function generateChartShort() {
      const cacheKey = `shortdata_${symbol}`;
      const oneDayMs = 1000 * 60 * 60 * 24;
      if (!plotData['short'] || !plotData['outstanding_short']) {
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          try {
            const parsed = JSON.parse(cached);
            if (parsed.timestamp > Date.now() - oneDayMs) {
              plotData['short'] = parsed.short;
              plotData['outstanding_short'] = parsed.outstanding_short;
            }
          } catch (e) { }
        }
      }
      if (!plotData['short'] || !plotData['outstanding_short']) {
        localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), short: plotData['short'], outstanding_short: plotData['outstanding_short'] }));
      }

      const chartContainer = document.createElement('div');
      chartContainer.classList.add('chart-container');
      chartContainer.style.position = 'relative';
      chartContainer.style.borderRadius = '8px';
      chartContainer.style.overflow = 'hidden';
      chartContainer.style.border = '1px solid #2B3139';
      chartContainer.style.width = '100%';
      chartContainer.style.height = chartHeight + 'px';

      const chart = createChart(chartContainer, { ...chartOption, leftPriceScale: { visible: true }, width: chartContainer.offsetWidth, height: chartContainer.offsetHeight });
      chartAnnotation(chart, '%short');

      const ro = new ResizeObserver(entries => {
        for (let e of entries) requestAnimationFrame(() => chart.applyOptions({ width: e.contentRect.width, height: e.contentRect.height }));
      });
      ro.observe(chartContainer);
      createOrderSelection(chartContainer, 2, '%Short');

      let activeSeries = [];

      if (isDataEmpty) {
        chart.applyOptions({
          watermark: { visible: true, fontSize: 22, horzAlign: 'center', vertAlign: 'center', color: '#D1D4DC', text: "Please select symbol", fontFamily: 'Roboto' },
          layout: { attributionLogo: false, background: { type: 'solid', color: '#131722' }, textColor: '#787B86' },
          grid: { horzLines: { color: '#2B3139' }, vertLines: { color: '#2B3139' } },
        });
        addDummyData(chart);
      } else {
        const dataForSeries = generateData(plotData['short'], 'time', 'value');
        let short_series = chart.addLineSeries({ color: '#f72a2a', lastValueVisible: true, title: '% daily short', priceLineVisible: false });
        short_series.setData(dataForSeries);
        const dataForSeries1 = generateData(plotData['outstanding_short'], 'time', 'value');
        let short_series1 = chart.addLineSeries({ color: '#73f54c', lastValueVisible: true, title: 'outstandingshort', priceLineVisible: false, priceScaleId: 'left' });
        short_series1.setData(dataForSeries1);
        short_series1.applyOptions({ priceFormat: { type: 'volume' } });

        activeSeries = [short_series, short_series1]; // เก็บเข้า Array สำหรับ Sync

        chart.applyOptions({
          watermark: { visible: true, fontSize: 24, color: theme.palette.chart.watermark, text: symbol, horzAlign: 'center', vertAlign: 'center' },
          layout: { attributionLogo: false, background: { type: 'solid', color: theme.palette.background.default }, textColor: theme.palette.text.primary },
          grid: { horzLines: { color: theme.palette.divider }, vertLines: { color: theme.palette.divider } },
        });
        chart.priceScale('left').applyOptions({ autoScale: true, visible: true, borderVisible: true, scaleMargins: { top: 0.1, bottom: 0.1 } });

        let titlesVisible = false;
        const toggleButton = document.createElement('button');
        toggleButton.textContent = 'Show/Hide All';
        toggleButton.style.position = 'absolute';
        toggleButton.style.top = '50px'; // ย้ายมาอยู่ล่าง Dropdown
        toggleButton.style.left = '12px';  // จัดชิดซ้ายตรงกับ Dropdown
        toggleButton.style.zIndex = '100';
        toggleButton.style.background = '#2B3139';
        toggleButton.style.color = '#D1D4DC';
        toggleButton.style.border = '1px solid #363C4E';
        toggleButton.style.borderRadius = '4px';
        toggleButton.style.padding = '4px 8px';
        toggleButton.style.cursor = 'pointer';
        toggleButton.style.fontSize = '12px';

        toggleButton.addEventListener('click', () => {
          titlesVisible = !titlesVisible;
          const series = [short_series1, short_series];
          series.forEach(s => {
            if (s.options().title === 'outstandingshort' || s.options().title === '% daily short') {
              s.applyOptions({ title: titlesVisible ? s.options().title : '' });
            } else if (s.options().title === '') {
              if (s === short_series) {
                s.applyOptions({ title: titlesVisible ? 'outstandingshort' : '' });
              } else if (s === short_series1) {
                s.applyOptions({ title: titlesVisible ? '% daily short' : '' });
              }
            }
          });
        });
        chartContainer.appendChild(toggleButton);

        setTimeout(() => { chart.timeScale().applyOptions({ rightOffset: 5 }); }, 100);
        return [chart, [short_series, short_series1], chartContainer];
      }
      return [chart, [], chartContainer];
    }

    // ── Chart 3: PredictTrend ────────────────────────
    function generateChartFlow() {
      const chartContainer = document.createElement('div');
      chartContainer.classList.add('chart-container');
      chartContainer.style.position = 'relative';
      chartContainer.style.borderRadius = '8px';
      chartContainer.style.overflow = 'hidden';
      chartContainer.style.border = '1px solid #2B3139';
      chartContainer.style.width = '100%';
      chartContainer.style.height = chartHeight + 'px';

      const chart = createChart(chartContainer, { ...chartOption, width: chartContainer.offsetWidth, height: chartContainer.offsetHeight });
      chart.priceScale('right').applyOptions({ visible: false, textColor: 'transparent' });
      chart.priceScale('left').applyOptions({ visible: false, textColor: 'black' });
      chartAnnotation(chart, 'Predicted Trend');

      const ro = new ResizeObserver(entries => {
        for (let e of entries) requestAnimationFrame(() => chart.applyOptions({ width: e.contentRect.width, height: e.contentRect.height }));
      });
      ro.observe(chartContainer);
      createOrderSelection(chartContainer, 3, 'PredictTrend');

      let activeSeries = [];

      if (isDataEmpty) {
        chart.applyOptions({
          watermark: { visible: true, fontSize: 22, horzAlign: 'center', vertAlign: 'center', color: '#D1D4DC', text: "Please select symbol", fontFamily: 'Roboto' },
          layout: { attributionLogo: false, background: { type: 'solid', color: '#131722' }, textColor: '#787B86' },
          grid: { horzLines: { color: '#2B3139' }, vertLines: { color: '#2B3139' } },
        });
        chart.priceScale('right').applyOptions({ visible: true, textColor: '#787B86' });
        addDummyData(chart);
      } else {
        const series3_1 = chart.addLineSeries({ color: '#ffa34d', lineStyle: 0, lineWidth: 3, lastValueVisible: false, priceLineVisible: false });
        activeSeries = [series3_1]; // เก็บเข้า Array สำหรับ Sync

        chart.applyOptions({
          watermark: { visible: true, fontSize: 24, horzAlign: 'center', vertAlign: 'center', color: theme.palette.chart.watermark, text: symbol },
          layout: { attributionLogo: false, background: { type: 'solid', color: theme.palette.background.default }, textColor: theme.palette.text.primary },
          grid: { horzLines: { color: theme.palette.divider }, vertLines: { color: theme.palette.divider } },
        });
        const dataForSeries_1 = generateData(plotData['flow_accum'], 'time', 'value');
        series3_1.setData(dataForSeries_1);
        series3_1.applyOptions({ priceFormat: { type: 'volume' } });
        setTimeout(() => { chart.timeScale().applyOptions({ rightOffset: 5 }); }, 100);
      }
      return [chart, activeSeries, chartContainer];
    }

    // ── Chart 4: Peak ────────────────────────────────
    function generateChartPeak() {
      const chartContainer = document.createElement('div');
      chartContainer.classList.add('chart-container');
      chartContainer.style.position = 'relative';
      chartContainer.style.borderRadius = '8px';
      chartContainer.style.overflow = 'hidden';
      chartContainer.style.border = '1px solid #2B3139';
      chartContainer.style.width = '100%';
      chartContainer.style.height = chartHeight + 'px';

      const chart = createChart(chartContainer, { ...chartOption, width: chartContainer.offsetWidth, height: chartContainer.offsetHeight });
      chart.priceScale('right').applyOptions({ visible: false, textColor: 'transparent' });
      chart.priceScale('left').applyOptions({ visible: false, textColor: 'black' });
      chartAnnotation(chart, 'Peak');

      const ro = new ResizeObserver(entries => {
        for (let e of entries) requestAnimationFrame(() => chart.applyOptions({ width: e.contentRect.width, height: e.contentRect.height }));
      });
      ro.observe(chartContainer);
      createOrderSelection(chartContainer, 4, 'Peak');

      let activeSeries = [];

      if (isDataEmpty) {
        chart.applyOptions({
          watermark: { visible: true, fontSize: 22, horzAlign: 'center', vertAlign: 'center', color: '#D1D4DC', text: "Please select symbol", fontFamily: 'Roboto' },
          layout: { attributionLogo: false, background: { type: 'solid', color: '#131722' }, textColor: '#787B86' },
          grid: { horzLines: { color: '#2B3139' }, vertLines: { color: '#2B3139' } },
        });
        chart.priceScale('right').applyOptions({ visible: true, textColor: '#787B86' });
        addDummyData(chart);
      } else {
        const series_3 = chart.addLineSeries({ color: '#faed37', lineStyle: 0, lineWidth: 2, title: 'sum', lastValueVisible: false, priceLineVisible: false, priceScaleId: 'right' });
        activeSeries = [series_3]; // เก็บเข้า Array สำหรับ Sync

        const dataForSeries = generateData(filteredData2, 'time', 'value');
        chart.applyOptions({
          watermark: { visible: true, fontSize: 24, horzAlign: 'center', vertAlign: 'center', color: theme.palette.chart.watermark, text: symbol },
          layout: { attributionLogo: false, background: { type: 'solid', color: theme.palette.background.default }, textColor: theme.palette.text.primary },
          grid: { horzLines: { color: theme.palette.divider }, vertLines: { color: theme.palette.divider } },
        });
        dataForSeries.sort((a, b) => a.time < b.time ? -1 : a.time > b.time ? 1 : 0);
        series_3.setData(dataForSeries);

        let markers = [];
        let max_data = plotData['max_peaks'];
        const flow_value = plotData['flow_accum'].map(items => items.value);
        let noti_group_id = '';
        let isControl = false;
        window.addEventListener('keydown', (event) => { if (event.ctrlKey) { isControl = true; if (noti_group_id === '') noti_group_id = generateGuid(); } });
        window.addEventListener('keyup', () => { isControl = false; noti_group_id = ''; });

        chart.subscribeDblClick((param) => {
          let max_peaks = max_data['swap']['max'], min_peaks = max_data['swap']['min'];
          let b = false;
          for (let i = 0; i < markers.length; i++) {
            if (param['time'] == markers[i]['time']) {
              b = true; markers.splice(i, 1);
              let valueSelect = '';
              for (let [key, value] of param['seriesData']) valueSelect = value['value'];
              __fetching_data__({ url: `${base_api_url}/chat_bot_save_point`, method: "POST", body: JSON.stringify({ chart_name: "peak", value: valueSelect, method: "del", timestamp: param['time'] }) });
            }
          }
          if (!b) {
            let bMax = false, bMin = false, valueSelect = '', valuePosition = '', barPosition = '';
            for (let [key, value] of param['seriesData']) {
              if (max_peaks.includes(value['value'])) { valueSelect = value['value']; valuePosition = 'A'; bMax = true; barPosition = 'aboveBar'; }
              else if (min_peaks.includes(value['value'])) { valueSelect = value['value']; valuePosition = 'V'; bMin = true; barPosition = 'belowBar'; }
            }
            let colorCode = '', charCode = '';
            if (isControl) { if (bMax) { colorCode = '#00FF00'; charCode = 'U'; } else if (bMin) { colorCode = '#7b241c'; charCode = 'D'; } }
            else { if (bMax) { colorCode = '#008000'; charCode = 'U'; } else if (bMin) { colorCode = '#FF0000'; charCode = 'D'; } }
            markers = [...markers, { time: param['time'], position: barPosition, color: colorCode, shape: 'circle', text: charCode }];
            __fetching_data__({ url: `${base_api_url}/chat_bot_save_point`, method: "POST", body: JSON.stringify({ chart_name: "peak", value: valueSelect, position: valuePosition, last_value: flow_value[flow_value.length - 1], method: "add", symbol: plotData['symbol'], timestamp: param['time'], group_id: noti_group_id }) });
          }
          markers.sort((a, b) => a.time < b.time ? -1 : a.time > b.time ? 1 : 0);
          series_3.setMarkers(markers);
        });
        setTimeout(() => { chart.timeScale().applyOptions({ rightOffset: 5 }); }, 100);
      }
      return [chart, activeSeries, chartContainer];
    }

    // ── Chart 5: Shareholder 246 ─────────────────────
    function generateChart246() {
      const chartContainer = document.createElement('div');
      chartContainer.classList.add('chart-container');
      chartContainer.style.position = 'relative';
      chartContainer.style.borderRadius = '8px';
      chartContainer.style.overflow = 'hidden';
      chartContainer.style.border = '1px solid #2B3139';
      chartContainer.style.width = '100%';
      chartContainer.style.height = chartHeight + 'px';

      const chart = createChart(chartContainer, { ...chartOption, width: chartContainer.offsetWidth, height: chartContainer.offsetHeight });
      chartAnnotation(chart, 'Shareholder > 5%');

      const ro = new ResizeObserver(entries => {
        for (let e of entries) requestAnimationFrame(() => chart.applyOptions({ width: e.contentRect.width, height: e.contentRect.height }));
      });
      ro.observe(chartContainer);
      createOrderSelection(chartContainer, 5, 'Shareholder');

      const seriesArray = [];
      const seriesTitles = [];
      let activeSeries = [];

      if (isDataEmpty) {
        chart.applyOptions({
          watermark: { visible: true, fontSize: 22, horzAlign: 'center', vertAlign: 'center', color: '#D1D4DC', text: "Please select symbol", fontFamily: 'Roboto' },
          layout: { attributionLogo: false, background: { type: 'solid', color: '#131722' }, textColor: '#787B86' },
          grid: { horzLines: { color: '#2B3139' }, vertLines: { color: '#2B3139' } },
        });
        addDummyData(chart);
      } else {
        const data_59 = plotData['all_246'];
        const name_59 = plotData['name_246'].slice(1);
        const colorList = ['#FF3B30', '#FF9500', '#FFCC00', '#34C759', '#32D74B', '#5AC8FA', '#007AFF', '#AF52DE', '#BF5AF2', '#FF2D55', '#FF6B6B', '#FF8200', '#FF5E3A', '#FFB300', '#66D4CF', '#FFC300', '#50C878', '#5856D6', '#8E44AD', '#1ABC9C'];

        for (let i = 0; i < name_59.length; i++) {
          const data = data_59[i], name = name_59[i], color = colorList[i % colorList.length];
          const seriesData = generateData(data, 'time', 'value');

          const seriesWithoutTitle = chart.addLineSeries({ color });
          seriesWithoutTitle.applyOptions({ priceFormat: { type: 'volume' }, visible: false, crosshairMarkerVisible: false });
          seriesWithoutTitle.setData(seriesData);

          const seriesWithTitle = chart.addLineSeries({ title: `${name}`, color });
          seriesWithTitle.applyOptions({ priceFormat: { type: 'volume' } });
          seriesWithTitle.setData(seriesData);

          seriesArray.push([seriesWithoutTitle, seriesWithTitle]);
          seriesTitles.push(name);
          activeSeries.push(seriesWithoutTitle); // เก็บตัวที่เป็นกราฟจริงๆ สำหรับ Sync
        }

        chart.applyOptions({
          watermark: { visible: true, fontSize: 24, color: theme.palette.chart.watermark, text: symbol, horzAlign: 'center', vertAlign: 'center' },
          layout: { attributionLogo: false, background: { type: 'solid', color: theme.palette.background.default }, textColor: theme.palette.text.primary },
          grid: { horzLines: { color: theme.palette.divider }, vertLines: { color: theme.palette.divider } },
        });

        // Toggle visibility logic
        let titleVisibilityState = false;
        function toggleAllSeriesTitleVisibility() {
          seriesArray.forEach(seriesPair => {
            const [seriesWithoutTitle, seriesWithTitle] = seriesPair;
            if (titleVisibilityState) {
              seriesWithoutTitle.applyOptions({ visible: true });
              seriesWithTitle.applyOptions({ visible: false });
            } else {
              seriesWithoutTitle.applyOptions({ visible: false });
              seriesWithTitle.applyOptions({ visible: true });
            }
          });
          titleVisibilityState = !titleVisibilityState;
        }

        const toggleButton = document.createElement('button');
        toggleButton.textContent = 'Hide/Show All';
        toggleButton.style.position = 'absolute';
        toggleButton.style.top = '50px'; // ย้ายมาอยู่ล่าง Dropdown
        toggleButton.style.left = '12px';  // จัดชิดซ้ายตรงกับ Dropdown
        toggleButton.style.zIndex = '100';
        toggleButton.style.background = '#2B3139';
        toggleButton.style.color = '#D1D4DC';
        toggleButton.style.border = '1px solid #363C4E';
        toggleButton.style.borderRadius = '4px';
        toggleButton.style.padding = '4px 8px';
        toggleButton.style.cursor = 'pointer';
        toggleButton.style.fontSize = '12px';
        toggleButton.addEventListener('click', toggleAllSeriesTitleVisibility);
        chartContainer.appendChild(toggleButton);

        chart.subscribeClick(mouseParams => {
          if (!mouseParams || !mouseParams.point || !mouseParams.hoveredSeries) return;
          const clickedSeries = mouseParams.hoveredSeries;
          const seriesIndex = seriesArray.findIndex(s => s.includes(clickedSeries));
          if (seriesIndex === -1) return;

          const [seriesWithoutTitle, seriesWithTitle] = seriesArray[seriesIndex];

          if (seriesWithTitle.options().visible) {
            seriesWithoutTitle.applyOptions({ visible: true });
            seriesWithTitle.applyOptions({ visible: false });
          } else {
            seriesWithoutTitle.applyOptions({ visible: false });
            seriesWithTitle.applyOptions({ visible: true });
          }
        });

        // Setup initial view
        seriesArray.forEach(seriesPair => {
          seriesPair[0].applyOptions({ visible: true });
          seriesPair[1].applyOptions({ visible: false });
        });

        setTimeout(() => { chart.timeScale().applyOptions({ rightOffset: 5 }); }, 100);
      }
      return [chart, activeSeries, chartContainer];
    }

    // ── Chart 6: Manager 59 ──────────────────────────
    function generateChart59() {
      const chartContainer = document.createElement('div');
      chartContainer.classList.add('chart-container');
      chartContainer.style.position = 'relative'; // ✅ เพิ่มมาเพื่อความปลอดภัย
      chartContainer.style.borderRadius = '8px'; // ✅ แก้เป็น 8px
      chartContainer.style.overflow = 'hidden';
      chartContainer.style.width = '100%'; // ✅ แก้เป็น 100%
      chartContainer.style.border = '1px solid #2B3139'; // ✅ แก้สีเป็นเทาเข้ม
      chartContainer.style.height = chartHeight + 'px';

      const chart = createChart(chartContainer, { ...chartOption, width: chartContainer.offsetWidth, height: chartContainer.offsetHeight });
      chartAnnotation(chart, 'manager');

      const ro = new ResizeObserver(entries => {
        for (let e of entries) requestAnimationFrame(() => chart.applyOptions({ width: e.contentRect.width, height: e.contentRect.height }));
      });
      ro.observe(chartContainer);
      createOrderSelection(chartContainer, 6, 'manager');

      const seriesArray = [];
      const seriesTitles = [];
      let activeSeries = [];

      if (isDataEmpty) {
        chart.applyOptions({
          watermark: { visible: true, fontSize: 22, horzAlign: 'center', vertAlign: 'center', color: '#D1D4DC', text: "Please select symbol", fontFamily: 'Roboto' },
          layout: { attributionLogo: false, background: { type: 'solid', color: '#131722' }, textColor: '#787B86' },
          grid: { horzLines: { color: '#2B3139' }, vertLines: { color: '#2B3139' } },
        });
        addDummyData(chart);
      } else {
        const data_59 = plotData['all_59'];
        const name_59 = plotData['name_59'].slice(1);
        const colorList = ['#FF3B30', '#FF9500', '#FFCC00', '#34C759', '#32D74B', '#5AC8FA', '#007AFF', '#AF52DE', '#BF5AF2', '#FF2D55', '#FF6B6B', '#FF8200', '#FF5E3A', '#FFB300', '#66D4CF', '#FFC300', '#50C878', '#5856D6', '#8E44AD', '#1ABC9C'];

        for (let i = 0; i < name_59.length; i++) {
          const data = data_59[i], name = name_59[i], color = colorList[i % colorList.length];
          console.log(data);

          const seriesData = generateData(data, 'time', 'value');
          console.log(seriesData);

          const series_59_without_title = chart.addLineSeries({ color });
          series_59_without_title.applyOptions({ priceFormat: { type: 'volume' }, visible: false, crosshairMarkerVisible: false });
          series_59_without_title.setData(seriesData);

          const series_59_with_title = chart.addLineSeries({ title: `${name}`, color });
          series_59_with_title.applyOptions({ priceFormat: { type: 'volume' } });
          series_59_with_title.setData(seriesData);

          seriesArray.push([series_59_without_title, series_59_with_title]);
          seriesTitles.push(name);
          activeSeries.push(series_59_without_title); // เก็บตัวที่เป็นกราฟจริงๆ สำหรับ Sync
        }

        chart.applyOptions({
          watermark: { visible: true, fontSize: 24, color: theme.palette.chart.watermark, text: symbol, horzAlign: 'center', vertAlign: 'center' },
          layout: { attributionLogo: false, background: { type: 'solid', color: theme.palette.background.default }, textColor: theme.palette.text.primary },
          grid: { horzLines: { color: theme.palette.divider }, vertLines: { color: theme.palette.divider } },
        });

        // Toggle visibility logic
        let titleVisibilityState = false;
        function toggleAllSeriesTitleVisibility() {
          seriesArray.forEach(seriesPair => {
            const [seriesWithoutTitle, seriesWithTitle] = seriesPair;
            if (titleVisibilityState) {
              seriesWithoutTitle.applyOptions({ visible: true });
              seriesWithTitle.applyOptions({ visible: false });
            } else {
              seriesWithoutTitle.applyOptions({ visible: false });
              seriesWithTitle.applyOptions({ visible: true });
            }
          });
          titleVisibilityState = !titleVisibilityState;
        }

        const toggleButton = document.createElement('button');
        toggleButton.textContent = 'Show/Hide All';
        toggleButton.style.position = 'absolute';
        toggleButton.style.top = '50px'; // ย้ายมาอยู่ล่าง Dropdown
        toggleButton.style.left = '12px';  // จัดชิดซ้ายตรงกับ Dropdown
        toggleButton.style.zIndex = '100';
        toggleButton.style.background = '#2B3139';
        toggleButton.style.color = '#D1D4DC';
        toggleButton.style.border = '1px solid #363C4E';
        toggleButton.style.borderRadius = '4px';
        toggleButton.style.padding = '4px 8px';
        toggleButton.style.cursor = 'pointer';
        toggleButton.style.fontSize = '12px';
        toggleButton.addEventListener('click', toggleAllSeriesTitleVisibility);
        chartContainer.appendChild(toggleButton);

        // Click event for line isolation and title toggle
        chart.subscribeClick(mouseParams => {
          if (!mouseParams || !mouseParams.point || !mouseParams.hoveredSeries) return;
          const clickedSeries = mouseParams.hoveredSeries;

          seriesArray.forEach(seriesPair => {
            seriesPair[0].applyOptions({ lastValueVisible: false, priceLineVisible: false });
          });

          const seriesIndex = seriesArray.findIndex(s => s.includes(clickedSeries));
          if (seriesIndex === -1) return;

          const [seriesWithoutTitle, seriesWithTitle] = seriesArray[seriesIndex];
          seriesWithoutTitle.applyOptions({ lastValueVisible: true, priceLineVisible: true });

          if (seriesWithTitle.options().visible) {
            seriesWithoutTitle.applyOptions({ visible: true });
            seriesWithTitle.applyOptions({ visible: false });
            seriesArray.forEach(seriesPair => {
              seriesPair[0].applyOptions({ lastValueVisible: true, priceLineVisible: true });
            });
          } else {
            seriesWithoutTitle.applyOptions({ visible: false });
            seriesWithTitle.applyOptions({ visible: true });
          }
        });

        // Setup initial view
        seriesArray.forEach(seriesPair => {
          seriesPair[0].applyOptions({ visible: true });
          seriesPair[1].applyOptions({ visible: false });
        });

        setTimeout(() => { chart.timeScale().applyOptions({ rightOffset: 5 }); }, 100);
      }
      return [chart, activeSeries, chartContainer];
    }

    // ── Build all charts ──────────────────────────────────────────────────────
    const [chart1, series1, chartContainer1] = generateChartLast();
    const [chart8, series8, chartContainer8] = generateChartShort();
    const [chart4, series4, chartContainer4] = generateChartFlow();
    const [chart2, series2, chartContainer2] = generateChartPeak();
    const [chart6, series6, chartContainer6] = generateChart246();
    const [chart5, series5, chartContainer5] = generateChart59();

    let allChartContainers, allGenerators, allSeries, charts;

    if (userDetail.permissions?.permission?.chatBot9Chanel?.read) {
      allChartContainers = [chartContainer1, chartContainer8, chartContainer4, chartContainer2, chartContainer6, chartContainer5];
      allSeries = [series1, series8, series4, series2, series6, series5];
      charts = [chart1, chart8, chart4, chart2, chart6, chart5];

      if (!window.myCharts) window.myCharts = {};
      window.myCharts['chart'] = chart1;

      for (const [key, value] of chartOrder) {
        const idx = value - 1;
        if (key === 'Last') { allChartContainers[idx] = chartContainer1; allSeries[idx] = series1; charts[idx] = chart1; }
        else if (key === '%Short') { allChartContainers[idx] = chartContainer8; allSeries[idx] = series8; charts[idx] = chart8; }
        else if (key === 'PredictTrend') { allChartContainers[idx] = chartContainer4; allSeries[idx] = series4; charts[idx] = chart4; }
        else if (key === 'Peak') { allChartContainers[idx] = chartContainer2; allSeries[idx] = series2; charts[idx] = chart2; }
        else if (key === 'Shareholder') { allChartContainers[idx] = chartContainer6; allSeries[idx] = series6; charts[idx] = chart6; }
        else if (key === 'manager') { allChartContainers[idx] = chartContainer5; allSeries[idx] = series5; charts[idx] = chart5; }
      }
    } else {
      allChartContainers = [chartContainer1, chartContainer4, chartContainer5, chartContainer6, chartContainer8];
      allSeries = [series1, series4, series5, series6, series8];
      charts = [chart1, chart4, chart5, chart6, chart8];
    }

    // Sync charts (แก้บัคเรื่อง Crosshair Sync ให้ทำงานได้สมบูรณ์)
    if (!isDataEmpty) {
      function syncChart() {
        let isSyncingLogicalRange = false; // ป้องกัน Loop ตอนซูมกราฟ

        charts.forEach((currentChart, currentIndex) => {
          // 1. Sync แกนเวลา (Zoom & Pan)
          currentChart.timeScale().subscribeVisibleLogicalRangeChange(timeRange => {
            if (isSyncingLogicalRange) return;
            isSyncingLogicalRange = true;
            charts.forEach((otherChart, otherIndex) => {
              if (currentIndex !== otherIndex && timeRange) {
                otherChart.timeScale().setVisibleLogicalRange(timeRange);
              }
            });
            isSyncingLogicalRange = false;
          });

          // 2. Sync เป้าเล็งแนวตั้ง (Crosshair Move)
          currentChart.subscribeCrosshairMove(param => {
            const seriesArray = allSeries[currentIndex];
            if (!seriesArray || !seriesArray[0]) return;

            const dataPoint = getCrosshairDataPoint(seriesArray[0], param);

            charts.forEach((otherChart, otherIndex) => {
              if (currentIndex !== otherIndex) {
                // ถ้าเมาส์ลอยออกนอกกราฟปัจจุบัน หรือไม่มีข้อมูล -> ล้างเป้าเล็งกราฟอื่นๆ
                if (!param.time || param.point.x < 0 || param.point.y < 0) {
                  otherChart.clearCrosshairPosition();
                } else if (dataPoint) {
                  const otherSeriesArray = allSeries[otherIndex];
                  if (otherSeriesArray && otherSeriesArray.length > 0) {
                    otherSeriesArray.forEach(otherSeries => {
                      syncCrosshair(otherChart, otherSeries, dataPoint);
                    });
                  }
                }
              }
            });
          });
        });
      }
      syncChart();
      window.syncChart = syncChart;
    }

    // ── Append containers directly ──
    allChartContainers.forEach((container) => {
      responseContainer.appendChild(container);
    });

    return responseContainer;
  };

  const displayResponse = (response, user_input) => {
    const chatbox = document.getElementById('chatbox');
    const responseContainer = document.createElement('div');
    responseContainer.classList.add('response-container');
    const downloadButton = document.createElement('button');
    downloadButton.classList.add('download-button');
    downloadButton.innerHTML = '👇Export as CSV';
    downloadButton.onclick = () => exportCsv(response.csv_data, user_input);
    responseContainer.appendChild(downloadButton);
    const botResponseContainer = document.createElement('div');
    botResponseContainer.innerHTML = response.bot_response;
    responseContainer.appendChild(botResponseContainer);
    chatbox.appendChild(responseContainer);
    initializeDataTable(botResponseContainer);
  };

  function saveChartOrder() {
    setLoading(true);
    const chartOrderSort = new Map([...chartOrder.entries()].sort((a, b) => a[1] - b[1]));
    const params = {};
    let counter = 1;
    for (const [key] of chartOrderSort) { params["d" + counter] = key; counter++; }
    __fetching_data__({ url: `${base_api_url}/chartorder/save`, method: "POST", body: JSON.stringify(params) })
      .then(() => { showToast("บันทึกรูปแบบกราฟเรียบร้อยแล้ว 💾", "success"); })
      .finally(() => setLoading(false));
  }

  function goToLastData() {
    const chart1 = window.myCharts?.['chart'];
    if (chart1) chart1.timeScale().scrollToPosition(7, false);
  }

  // ── Utility functions ────────────────────────────
  function generateDataBackup(data, date_column = 'date', field = 'value') {
    const tzOffset = 7 * 60 * 60 * 1000;
    return data.map(d => ({
      time: (new Date(d[date_column]).getTime() + tzOffset) / 1000,
      value: parseFloat(d[field]) || 0
    }));
  }

  function generateData(data, date_column = 'date', field = 'value') {
    const tzOffset = 7 * 60 * 60 * 1000;
    const mapped = data.map(d => ({
      time: (new Date(d[date_column]).getTime() + tzOffset) / 1000,
      value: parseFloat(d[field]) || 0
    }));
  
    // Sort ascending by time
    mapped.sort((a, b) => a.time - b.time);
  
    // De-dupe: lightweight-charts also rejects duplicate/equal timestamps,
    // keep the last value for any repeated time
    const deduped = [];
    for (const point of mapped) {
      if (deduped.length && deduped[deduped.length - 1].time === point.time) {
        deduped[deduped.length - 1] = point; // overwrite with latest
      } else {
        deduped.push(point);
      }
    }
    return deduped;
  }

  function generateGuid() { return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); }

  function syncCrosshair(chart, series, dataPoint) {
    if (dataPoint) { chart.setCrosshairPosition(dataPoint.value, dataPoint.time, series); return; }
    chart.clearCrosshairPosition();
  }
  function getCrosshairDataPoint(series, param) {
    if (!param.time) return null;
    return param.seriesData.get(series) || null;
  }

  function initializeDataTable(container) {
    const dataTable = container.querySelector('table');
    if (dataTable && !$(dataTable).DataTable()) $(dataTable).DataTable({ index: false });
  }

  // ============================================================
  // WaveSkeleton
  // ============================================================
  function WaveSkeleton({ delay = 0 }) {
    return (
      <div className="w-full h-[210px] bg-[#0f172a] rounded-lg overflow-hidden relative">
        <style>{`
        @keyframes shimmer {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
        <div className="absolute inset-0 flex flex-col justify-between p-3">
          <div className="flex gap-2">
            <div className="h-2 rounded-full bg-slate-800 w-1/3" />
            <div className="h-2 rounded-full bg-slate-800 w-1/5" />
          </div>
          <div className="flex-1 my-3 rounded bg-slate-800/60" />
          <div className="flex gap-3 justify-between">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-2 rounded-full bg-slate-800 flex-1" />
            ))}
          </div>
        </div>
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, rgba(56,189,248,0.08) 40%, rgba(125,211,252,0.18) 50%, rgba(56,189,248,0.08) 60%, transparent 100%)",
            animation: "shimmer 1.8s ease-in-out infinite",
            animationDelay: `${delay}s`,
          }}
        />
      </div>
    );
  }

  // ════════════════════════════════════════════════
  // RENDER
  // ════════════════════════════════════════════════
  return (
    <>
      <style>
        {`
      /* สไตล์ Dropdown ให้เหมือนรูปต้นฉบับเป๊ะๆ */
      .header-selection {
        position: absolute;
        top: 12px;
        left: 12px;
        z-index: 100;
        background-color: #2B3139;
        color: #D1D4DC;
        border: 1px solid #363C4E;
        border-radius: 4px;
        padding: 4px 8px;
        font-family: Roboto, sans-serif;
        font-size: 12px;
        cursor: pointer;
        outline: none;
      }
      .header-selection:hover {
        border-color: #4C525E;
      }
      @keyframes cbi-spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
      .cbi-spin-icon { animation: cbi-spin 0.5s linear; }
        `}
      </style>
      <Container
        style={{
          marginTop: -5,
          width: '100%',
          height: isMobile ? '90vh' : 'calc(100vh - var(--top-bar-height))',
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
          maxWidth: '25000px',
          background: '#0B0E14' // พื้นหลังหลักสีดำเข้มแบบหน้าจอกราฟ
        }}>
        <Paper
          elevation={3}
          style={{
            padding: 10,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            maxWidth: '25000px',
            background: 'transparent',
            justifyContent: 'flex-start',
            overflow: 'hidden'
          }}>

          {/* ── TOP BAR ── */}
          <div style={{ width: '100%', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ position: 'relative', width: isMobile ? '100%' : '45%' }}>
              <Autocomplete
                freeSolo
                options={filteredSymbols}
                inputValue={inputValue}
                onInputChange={(_, val) => { setInputValue(val); setShowDropdown(true); }}
                onChange={(_, val) => { if (val) { setInputValue(val); handleSendMessage(val); setShowDropdown(false); } }}
                sx={{ width: '100%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputRef={searchInputRef}
                    placeholder="Type a Symbol..."
                    variant="outlined"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      sx: { backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '30px', color: 'white', fontSize: '14px', height: '40px', '& fieldset': { border: 'none' } },
                      endAdornment: inputValue ? (
                        <IconButton size="small" onClick={() => { setInputValue(''); setShowDropdown(false); }} sx={{ color: 'rgba(255,255,255,0.5)' }}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      ) : null
                    }}
                  />
                )}
                disabled={isMessageSent}
                componentsProps={{ paper: { sx: { backgroundColor: '#0f172a', border: '1px solid #334155', borderRadius: '12px', '& .MuiAutocomplete-option': { color: '#cbd5e1', fontSize: '14px' } } } }}
              />
            </div>
            {/* Action buttons */}
            <div style={{ display: 'flex', gap: '10px' }}>
              <IconButton sx={{ color: 'white', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.3)' }} onClick={() => saveChartOrder()} title="Save chart order">
                <SaveOutlinedIcon />
              </IconButton>
              <IconButton
                sx={{ color: 'white', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.3)' }}
                onClick={() => {
                  setInputValue('');
                  setShowDropdown(false);
                  globalResponse = null;
                  setIsSymbolSelected(false);
                  setRefreshing(true);
                  const chatbox = document.getElementById('chatbox');
                  if (chatbox) chatbox.innerHTML = '';
                  const chatboxEmpty = document.getElementById('chatboxEmpty');
                  if (chatboxEmpty) chatboxEmpty.innerHTML = '';
                  generateEmptyChart();
                  setTimeout(() => { setRefreshing(false); searchInputRef.current?.focus(); }, 500);
                }}
              >
                <RefreshIcon className={refreshing ? 'cbi-spin-icon' : ''} />
              </IconButton>
              <IconButton sx={{ color: 'white', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.3)' }} onClick={() => goToLastData()} title="Go to latest">
                <FastForwardIcon />
              </IconButton>
            </div>
          </div>

          {/* ── CHART AREA ── */}
          <div style={{ display: 'flex' }}>
            <div
              id="resChatBox"
              ref={resChatBoxRef}
              style={{
                width: '90%',
                flexGrow: 1,
                position: 'relative',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}>

              {/* 1. Skeleton */}
              {(isInitialLoading || isMessageSent) && (
                <div style={{ width: '100%', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px' }}>
                  {['Last', '%Short', 'PredictTrend', 'Peak', 'Shareholder', 'manager'].map((label, idx) => (
                    <WaveSkeleton key={label} delay={idx * 0.2} />
                  ))}
                </div>
              )}

              {/* 2. No Data */}
              <div id="chatboxEmpty" style={{ width: '100%', display: (!isInitialLoading && !isSymbolSelected && !isMessageSent) ? 'block' : 'none' }} />

              {/* 3. Real Data */}
              <div id="chatbox" style={{ width: '100%', display: (isSymbolSelected && !isMessageSent) ? 'block' : 'none' }} />
            </div>
            <div className="ml-2" style={{ width: '10%' }}>
              <RightMenu handleSendMessage={handleSendMessage} />
            </div>
          </div>
          <ToastContainer toasts={toasts} />
        </Paper>
      </Container>
    </>
  );
};

export default ChatBotV2Page;